module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ./~/react-modal/lib/index.js
// module id = 499
// module chunks = 4 6 7 8 9 12 13 16 21 55 56